import { queryClient } from '@/queries';
import { employeeQueries } from './employee.query';
import { employeesQueryKeys } from './employee.keys';

export const invalidateEmployeeListQueries = () => {
  return queryClient.invalidateQueries({ queryKey: employeesQueryKeys.getList(), exact: false });
};

export const invalidateEmployeeItemQueries = (employeeId: string) => {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: employeeQueries.item(employeeId).queryKey }),
    queryClient.invalidateQueries({ queryKey: employeeQueries.employee(employeeId).queryKey }),
  ]);
};
